import { Link } from 'react-router-dom';

export default function OverviewSection() {
  return (
    <section id="overview" className="py-20 px-6 scroll-mt-32">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-teal-700 bg-teal-50 text-sm font-medium px-4 py-1.5 rounded-full mb-4">
              <i className="ri-compass-3-line"></i>
              Why Roseville?
            </span>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">One of California&apos;s Best Places to Live</h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              Consistently ranked among the top cities in California, Roseville combines small-town charm with big-city amenities. Located just 18 miles northeast of Sacramento, you&apos;ll enjoy 269 sunny days per year<sup className="text-teal-600 font-medium cursor-pointer" title="Source: U.S. Climate Data">*</sup>, award-winning parks, top-rated schools, and a thriving local economy.
            </p>

            <div className="space-y-3 mb-8">
              {[
                { icon: 'ri-shield-check-line', text: 'One of the safest cities in the Sacramento metro area', source: 'FBI Crime Data & SafeWise' },
                { icon: 'ri-tree-line', text: '80+ parks and 42 miles of trails for outdoor recreation', source: 'City of Roseville Parks & Recreation' },
                { icon: 'ri-store-2-line', text: 'World-class shopping at Westfield Galleria & The Fountains', source: 'Westfield Corporation' },
                { icon: 'ri-car-line', text: '90 minutes to Lake Tahoe, 2 hours to San Francisco', source: 'Google Maps' },
                { icon: 'ri-briefcase-line', text: 'Growing tech hub with major employers like HP & Oracle', source: 'Roseville Economic Development' },
              ].map((item) => (
                <div key={item.text} className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-teal-600`}></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-700">{item.text}</p>
                    <p className="text-xs text-gray-400 mt-0.5">Source: {item.source}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-3">
              <Link
                to="/real-estate"
                className="inline-flex items-center gap-2 bg-teal-600 text-white text-sm font-medium px-5 py-2.5 rounded-lg hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-home-4-line"></i>
                Browse Real Estate
              </Link>
              <Link
                to="/jobs"
                className="inline-flex items-center gap-2 border border-gray-200 text-gray-700 text-sm font-medium px-5 py-2.5 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-briefcase-line"></i>
                Find Jobs
              </Link>
            </div>
          </div>

          <div className="relative">
            <div className="w-full h-[420px] rounded-2xl overflow-hidden shadow-lg">
              <img
                src="https://public.readdy.ai/ai/img_res/79bba3aee45b3aba82ca63bfcfad49bd.jpg"
                alt="Roseville California community park with families enjoying outdoor activities"
                title="Roseville California parks and recreation - community living"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 bg-white rounded-xl shadow-lg p-4 flex items-center gap-3">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-amber-100">
                <i className="ri-award-fill text-amber-600 text-xl"></i>
              </div>
              <div>
                <p className="text-sm font-bold text-gray-900">#3 Best City in CA</p>
                <p className="text-xs text-gray-500">Money Magazine 2024</p>
              </div>
            </div>
          </div>
        </div>

        {/* Sources Footer */}
        <div className="mt-12 pt-8 border-t border-gray-100">
          <p className="text-xs text-gray-400 leading-relaxed">
            <sup>*</sup> Data sources: U.S. Climate Data, FBI Uniform Crime Reporting, City of Roseville official statistics, U.S. Census Bureau, and local government records. Statistics are updated annually and reflect the most recent available data.
          </p>
        </div>
      </div>
    </section>
  );
}
